import $ from 'jquery';
import 'slick-carousel';

// single-select
$('.nav-tabs').each(function () {
  const $group = $(this);

  $(this)
    .find('.nav-link')
    .on('click', function (e) {
      e.preventDefault();

      // hide all panes, deactivate all tabs
      $group.siblings('.tab-content').find('.tab-pane').removeClass('is-active');
      $group.find('.nav-item').removeClass('is-active');
      $group.find('.nav-link').removeClass('is-active');
      $group.find('.nav-item').attr('aria-selected', false);

      // get the pane to be activated
      const $pane = $($(this).attr('href'));

      $(`.${$pane.data('slider')}`).addClass('opacity-0');

      // position any slider
      if ($pane.data('slider')) {
        setTimeout(() => {
          $(`.${$pane.data('slider')}`).slick('setPosition');
        }, 10);
      }
      // show this pane

      $pane.addClass('is-active');

      setTimeout(() => {
        $(`.${$pane.data('slider')}`).addClass('opacity-100');
      }, 500);

      // activate this tab
      $(this).parents('.nav-item').addClass('is-active');
      $(this).parents('.nav-item').attr('aria-selected', true);
      $(this).addClass('is-active');
    });
});

$('.close-pane').on('click', function () {
  $(this).parents('.tab-pane').removeClass('is-active');
});

// multi-select

$('.nav-multi-tab').each(function () {
  checkNavArea($(this));
});

$('.nav-multi-tab').on('change', function () {
  checkNavArea($(this));
});

function checkNavArea($tab) {
  const selected = $tab.data('selected');

  // make the/any related checkbox match this tab's check status
  $(`.nav-multi-tab[data-selected='${selected}']`).prop('checked', $tab.prop('checked'));
  const toggleClass = $tab.data('toggle-class');
  const group = $tab.data('group');
  const $area = $tab.parents(`.nav-area-${group}`);
  const $checkedTabs = $area.find('.nav-multi-tab:checked');
  const $allTabs = $area.find('.nav-multi-tab');

  // if some are selected,  parse selected ones
  if ($checkedTabs.length) {
    $allTabs.each(function () {
      const selected = $(this).data('selected');
      const slider = $(this).data('slider');

      if ($(this).prop('checked')) {
        if (slider) {
          setTimeout(() => {
            $(`.${slider}`).slick('setPosition');
          }, 10);
        }
        $area.find(`.${group}-${selected}`).each(function () {
          $(this).removeClass(toggleClass);
        });
      } else {
        $area.find(`.${group}-${selected}`).each(function () {
          $(this).addClass(toggleClass);
        });
      }
    });

    // if all unselected, show all
  } else {
    $area.find('.multi-pane').each(function () {
      $(this).removeClass(toggleClass);
    });
  }
}

// multi-select drilldown

$('.tab-drilldown-area').each(function () {
  const drills = {};
  const $area = $(this);
  const $filters = $area.find('.drill-filters .drill-type');
  const toggleClass = $area.data('toggle-class');

  $filters.each(function () {
    const $drillFilter = $(this);
    const type = $drillFilter.data('type');
    drills[type] = [];
  });

  $area.find('.drill-tab').on('change', function () {
    const $tab = $(this);
    const group = $tab.data('group');
    const selected = $tab.data('selected');
    // group here is type (cab, drive, trim ..)
    // selected is value (2wd, 4wd ..)

    // make the/any related checkbox match this tab's checked status
    $area.find(`.drill-tab[data-selected='${selected}']`).prop('checked', $tab.prop('checked'));

    // track dill values
    if ($tab.prop('checked')) {
      drills[group].push(selected);
    } else {
      drills[group] = $.grep(drills[group], function (value) {
        return value != selected;
      });
    }

    runDrills($area, drills, toggleClass);
  });
});

function runDrills($area, drills, toggleClass) {
  $area.find('.drill-pane').each(function () {
    const $pane = $(this);
    const overallStatus = []; // i.e. [true, true, false]

    for (const group in drills) {
      const value = $pane.data(group);
      // check if this group has a filter set
      if (drills[group].length) {
        // true if has the filter AND the filter is set to a filtere value
        // false if does not have this property OR the property is not included in filtered
        overallStatus.push(value && drills[group].includes(value));
      } else {
        // not filtered by this group, so flag true automatically
        overallStatus.push(true);
      }
    }

    if (overallStatus.includes(false)) {
      $pane.addClass(toggleClass);
    } else {
      $pane.removeClass(toggleClass);
    }
  });
}
